// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Home_text-gradient__2k6fh","loaderContainer":"Home_loaderContainer__3AZxE","loader":"Home_loader__3fasq"};